export const SCHEDULE_APPOINTMENT_ENDPOINT = '/booking-portal/Appointment/BookExperience';
